import { PayUService } from './../services/payu.service';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { LocalStorageService } from '../services/local-storage.service';

@Component({
    selector: 'app-service-offer-payment',
    templateUrl: './service-offer-payment.component.html',
    styleUrls: ['../../assets/css/bootstrap.min.css', './scss/checkout.css', './scss/aboutus.css', './scss/buttons.css',
        './scss/dedicated-servers-configurator.css', './scss/header-configurator.css', './scss/mixins.css', './scss/services.css']
})
export class ServiceOfferPaymentComponent implements OnInit {
    invoiceStorageURL = `${environment.api_url}`;


    // public payUUrl: any = '';
    // public accessToken: any = '';
    // public proformaNumber: any = '';
    public paymentInfo;

    constructor(
        //private payUService: PayUService,
        private localStorageService: LocalStorageService
    ) { }

    ngOnInit() {
        this.paymentInfo = this.localStorageService.get('paymentInfo');
        
        //this.payUUrl = this.payUService.payUPaymentURL;
        //this.accessToken = this.payUService.accessToken;
        //this.proformaNumber = this.payUService.proformaNumber;
//
        //this.payUUrl = this.localStorageService.get('payUURL');
        //this.accessToken = this.localStorageService.get('accessToken');
        //this.proformaNumber = this.localStorageService.get('proformaNumber');
    }
}



// WEBPACK FOOTER //
// ./src/app/service/service-offer-payment.component.ts